export const GetLatestLoginActivity = "/LoginActivity/GetLatestLoginActivity";

export const GetLoginActivityForm = "/LoginActivity/GetLoginActivityForm";

export const GetLoginActivityList = ({
  startDate,
  endDate,
  typeId,
  pageNumber,
  pageSize,
}) =>
  `/LoginActivity/GetLoginActivityList?TypeId=${typeId}&StartDate=${startDate}&EndDate=${endDate}&PageNumber=${pageNumber}&PageSize=${pageSize}`;
